import { defineMessages } from "react-intl";

const baseId = "t.pages.ReportStepOne.";

export default defineMessages({
  PanelTitle: {
    id: baseId + "PanelTitle",
    defaultMessage: "Search Reports",
  },
  noReportFound: {
    id: baseId + "noReportFound",
    defaultMessage: "No reports found",
  },
  allFilterLabelForm: {
    id: baseId + "allFilterLabelForm",
    defaultMessage: "ID,Name,Description",
  },
  CTA_BACK: {
    id: baseId + "CTA_BACK",
    defaultMessage: "Back to Home",
  },
});
